import { inject, Injectable } from '@angular/core';
import { ROUTES } from '@core/constants';

import { IResponseHttp, IUser } from '@core/models';
import { ApiService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private readonly api = inject(ApiService);

  async getAllUsers(): Promise<IUser[]> {
    const result = await this.api.get<IResponseHttp>(ROUTES.ADMIN_GET_USERS);
    return result.payload as IUser[];
  }

  async createUser(userData: {
    name: string;
    document: string;
    roles: string[];
  }): Promise<IUser> {
    const result = await this.api.post<IResponseHttp>(ROUTES.ADMIN_CREATE_USER, userData);
    return result.payload as IUser;
  }

  async resetPassword(userId: string): Promise<void> {
    await this.api.get<IResponseHttp>(ROUTES.ADMIN_RESET_PASSWORD(userId));
    return;
  }

  async updateUser(
    userId: string,
    userData: {
      name?: string;
      document?: string;
      roles?: string[];
    },
  ): Promise<IUser> {
    const result = await this.api.patch<IResponseHttp>(
      ROUTES.ADMIN_UPDATE_USER(userId),
      userData,
    );
    return result.payload as IUser;
  }
}
